<template>
    <div>
        <confirmable-text-field
                v-bind="$attrs"
                v-if="confirmable"
                :autocomplete="autocomplete"
                confirm-icon="mdi-phone-check"
                :confirm-disabled="disabled || confirmDisabled"
                :disabled="disabled"
                :value="textFieldModel"
                @input="handleInput"
                :placeholder="textFieldPlaceholder"
        >
            <template v-for="(_, slot) of $slots" :slot="slot">
                <slot :name="slot"/>
            </template>

        </confirmable-text-field>
        <v-text-field
                v-bind="$attrs"
                v-if="!confirmable"
                :autocomplete="autocomplete"
                :disabled="disabled"
                :value="textFieldModel.value"
                @input="handleInput"
                :placeholder="textFieldPlaceholder"
        >
            <template v-for="(_, slot) of $slots" :slot="slot">
                <slot :name="slot"/>
            </template>

        </v-text-field>
    </div>
</template>

<script>
    import _ from 'lodash'
    import t from 'typy'
    import ConfirmableTextField from './ConfirmableTextField'

    const defaultModel = {
        number: '',
        is_confirmed: false,
    }

    export default {
        name: "PhoneTextField",
        components: {
            ConfirmableTextField,
        },
        inheritAttrs: false,
        props: {
            value: {
                type: Object,
                required: false,
                default: () => defaultModel,
            },
            autocomplete: {
                required: false,
                type: String,
                default: 'autocomplete',
            },
            confirmable: {
                type: Boolean,
                required: false,
                default: false,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data: (vm) => ({
            textFieldModel: {},
            textFieldPlaceholder: vm.l('forms.phoneTextField.placeholder'),
            confirmDisabled: false,
            shouldBeConfirmed: defaultModel.is_confirmed,
        }),
        methods: {
            convertPhoneToTextField(value) {

                const converted = {
                    value: '',
                    is_confirmed: false,
                }

                if (_.isString(value) || _.isSafeInteger(value)) {
                    converted.value = value
                } else if (_.isObject(value)) {
                    if (_.has(value, 'number')) {
                        converted.value = value.number
                    }
                    if (_.has(value, 'is_confirmed')) {
                        converted.is_confirmed = !!value.is_confirmed
                    }
                }

                converted.value = this.formatNumber(converted.value)

                return converted
            },
            shouldDisableConfirm: number => !number, //_.toString(number).replace(/[^\d]/g, '').length < 9,
            formatNumber: number => {
                number = _.toString(number).trim();
                const plusPrefixed = _.startsWith(number, '+')
                number = number.replace(/[^\d]/g, '').replace(/^0+/, '');
                if (number.length === 12 && _.startsWith(number, '420')) {
                    number = number.slice(3)
                }
                switch (true) {
                    case (!plusPrefixed && number.length === 9):
                        return number.match(/.{3}/g).join(' ')
                    case (!plusPrefixed && number.length > 9):
                        return '+' + number
                    default:
                        return (plusPrefixed ? '+' : '') + number
                }
            },
            handleInput(textField) {
                if (_.isObject(textField)) {
                    this.handleConfirmableInput(textField)
                } else {
                    this.handleUnconfirmableInput(textField)
                }
            },
            handleConfirmableInput(textField) {
                if (this.textFieldModel.number !== textField.value || this.textFieldModel.is_confirmed !== textField.is_confirmed) {
                    this.emitInput({
                        value: textField.value,
                        is_confirmed: textField.is_confirmed,
                    })
                }
                this.textFieldModel = textField
            },
            handleUnconfirmableInput(textField) {
                if (this.textFieldModel.number !== textField.value || this.textFieldModel.is_confirmed !== textField.is_confirmed) {
                    this.emitInput({
                        value: textField,
                        is_confirmed: this.textFieldModel.is_confirmed,
                    })
                }
                this.textFieldModel.value = textField
            },
            emitInput(input = null) {

                if (!input) {
                    input = _.clone(this.textFieldModel)
                }

                const data = _.clone(t(this.value).safeObjectOrEmpty)

                if (_.has(input, 'is_confirmed')) {
                    data.is_confirmed = input.is_confirmed
                }
                if (_.has(input, 'value')) {
                    data.number = input.value.replace(/[^\d]/g, '')
                    if (data.number.length === 9) {
                        data.number = '420' + data.number
                    }
                }

                this.$emit('input', data)
            },
        },
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler(model) {
                    this.textFieldModel = this.convertPhoneToTextField(model)
                },
            },
            textFieldModel: {
                deep: true,
                immediate: true,
                handler(textField) {
                    if (textField.is_confirmed) {
                        this.shouldBeConfirmed = true
                    }
                    this.confirmDisabled = this.shouldDisableConfirm(textField.value)
                }
            },
            confirmDisabled: {
                handler(disabled, wasAlreadyDisabled) {
                    if (disabled !== wasAlreadyDisabled) {
                        const textField = _.clone(this.textFieldModel)
                        if (disabled) {
                            this.shouldBeConfirmed = textField.is_confirmed
                            textField.is_confirmed = false
                        } else {
                            textField.is_confirmed = this.shouldBeConfirmed
                        }
                        this.textFieldModel = textField
                        if (!this.confirmable) {
                            this.emitInput()
                        }
                    }
                },
                immediate: true,
            },
        },

    }
</script>

<style scoped>

</style>